import { FunctionComponent } from 'react';
import {
  IcoArchiveOutline,
  IcoChartLeaderboard,
  IcoClusterFill,
  IcoFolderOutline,
  IcoHome,
  IcoProtectionCheck,
  IcoSearchEarth,
  IcoSellers,
} from '@marqvision/mds/assets';
import { MarqCommonEnumsClientClientRoleEnum } from '~/swagger/data-contracts';

type RouteGroup = {
  type: 'ROUTE_GROUP';
  to?: string;
  display?: {
    text: string;
    icon?: FunctionComponent;
    open?: boolean;
    divider?: boolean;
  };
  permission: {
    notAllowed: MarqCommonEnumsClientClientRoleEnum[];
  };
  items: Route[];
};
type Route = {
  type: 'ROUTE';
  to: string;
  display?: {
    text: string;
    icon?: FunctionComponent;
    open?: boolean;
    divider?: boolean;
  };
  permission: {
    notAllowed: MarqCommonEnumsClientClientRoleEnum[];
  };
};

// TODO: react-router와 연결하기
export const MARQ_COMMERCE_ROUTES: Array<RouteGroup | Route> = [
  {
    type: 'ROUTE',
    to: '/home',
    display: {
      text: 'Home',
      icon: IcoHome,
    },
    permission: {
      notAllowed: [MarqCommonEnumsClientClientRoleEnum.LimitedAccess],
    },
  },
  {
    type: 'ROUTE_GROUP',
    to: '/performance',
    items: [
      {
        type: 'ROUTE',
        to: '/performance',
        display: { text: 'Overview' },
        permission: { notAllowed: [] },
      },
      {
        type: 'ROUTE',
        to: '/performance-reports',
        display: { text: 'Reports' },
        permission: { notAllowed: [] },
      },
    ],
    display: {
      text: 'Performance',
      icon: IcoChartLeaderboard,
    },
    permission: {
      notAllowed: [MarqCommonEnumsClientClientRoleEnum.LimitedAccess],
    },
  },
  {
    type: 'ROUTE_GROUP',
    items: [
      {
        type: 'ROUTE',
        to: '/assets',
        display: { text: 'Assets' },
        permission: { notAllowed: [] },
      },
      {
        type: 'ROUTE',
        to: '/ip-portfolio',
        display: { text: 'IP Documents' },
        permission: { notAllowed: [] },
      },
      {
        type: 'ROUTE',
        to: '/official-image',
        display: { text: 'Official Images' },
        permission: { notAllowed: [] },
      },
      {
        type: 'ROUTE',
        to: '/library',
        display: { text: 'Infringing Images' },
        permission: { notAllowed: [] },
      },
      {
        type: 'ROUTE',
        to: '/authorized-sellers',
        display: { text: 'Authorized Sellers' },
        permission: { notAllowed: [] },
      },
    ],
    display: {
      text: 'Portfolio',
      open: false,
      divider: true,
      icon: IcoFolderOutline,
    },
    permission: { notAllowed: [] },
  },
  {
    type: 'ROUTE',
    to: '/detection',
    display: {
      text: 'Detection',
      icon: IcoSearchEarth,
    },
    permission: { notAllowed: [] },
  },
  {
    type: 'ROUTE',
    to: '/enforcement',
    display: {
      text: 'Enforcement',
      icon: IcoProtectionCheck,
    },
    permission: { notAllowed: [] },
  },
  {
    type: 'ROUTE',
    to: '/archived',
    display: {
      text: 'Archived',
      icon: IcoArchiveOutline,
      divider: true,
    },
    permission: { notAllowed: [] },
  },
  {
    type: 'ROUTE',
    to: '/seller',
    display: {
      text: 'Seller Analytics',
      icon: IcoSellers,
    },
    permission: { notAllowed: [] },
  },
  {
    type: 'ROUTE',
    to: '/seller/lab',
    display: {
      text: 'Seller Intel',
      icon: IcoClusterFill,
    },
    permission: { notAllowed: [] },
  },
];
export const getAllowedRoutes = (clientRole: MarqCommonEnumsClientClientRoleEnum) =>
  MARQ_COMMERCE_ROUTES.filter((route) => !route.permission.notAllowed.includes(clientRole));
